import { render } from "./ClockInStatus.vue?vue&type=template&id=5071673e&scoped=true&ts=true"
import script from "./ClockInStatus.vue?vue&type=script&lang=ts"
export * from "./ClockInStatus.vue?vue&type=script&lang=ts"

import "./ClockInStatus.vue?vue&type=style&index=0&id=5071673e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5071673e"]])

export default __exports__